import React from 'react';
import { makeStyles } from '@mui/styles';

export default function SelectedWorkstation(props) {
    const classes = useStyles();

    return <React.Fragment>
        <button className={classes.selectedLineNoZones} key={props.id}>{props.line}</button>
    </React.Fragment>
}

const useStyles = makeStyles({
    selectedLineNoZones: {
        fontSize: "14px  !important",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#4654FB",
        backgroundColor: "#E6E8FE",
        display: "inline-block",
        outline: "none",
        overflow: 'hidden',
        border: "1px solid white",
        borderRadius: "50%",
        width: "42px !important",
        height: "42px !important",
        textAlign: "center"
    }
});